/// <amd-module name="VSS/Platform/Components/Performance" />
export * from "./Performance/Performance";
